import { createTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { config } from '../configs/config';
import COLOURS from '../constants/colour';

const breakpoints = createBreakpoints({});

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: config.primaryColour,
      light: COLOURS.LightRed,
      contrastText: COLOURS.White,
    },
    success: {
      main: COLOURS.GoodGreen,
    },
    warning: {
      main: COLOURS.AlertOrange,
    },
    background: {
      default: '#f5f6fa',
      paper: '#fff',
    },
    text: {
      primary: COLOURS.Dark,
    },
    grey: {
      600: COLOURS.PortalGrey,
    },
  },
  typography: {
    fontFamily: "'Mulish', sans-serif",
    subtitle1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '24px',
    },
    subtitle2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '20px',
      lineHeight: '32px',
      textAlign: 'start',

      [breakpoints.down('md')]: {
        fontSize: '14px',
        lineHeight: '24px',
      },
    },
    h1: {
      textAlign: 'start',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '36px',
      lineHeight: '45px',
      letterSpacing: '-1px',

      [breakpoints.down('md')]: {
        fontSize: '24px',
        lineHeight: '30px',
        letterSpacing: 'initial',
      },
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '32px',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '24px',
    },
    h6: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '20px',
    },
    body1: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '24px',
    },
    body2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&:hover:not($disabled):not($focused):not($error) .MuiOutlinedInput-notchedOutline': {
          borderColor: COLOURS.PortalGrey,
        },
      },
      notchedOutline: {
        borderColor: COLOURS.PortalGrey,
      },
    },
  },
});

export default theme;
